import { render, staticRenderFns } from "./QuizStartScreen.vue?vue&type=template&id=5cde61f9&scoped=true&"
import script from "./QuizStartScreen.vue?vue&type=script&lang=ts&"
export * from "./QuizStartScreen.vue?vue&type=script&lang=ts&"
import style0 from "./QuizStartScreen.vue?vue&type=style&index=0&id=5cde61f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde61f9",
  null
  
)

export default component.exports